import { useState } from "react";

function GoodItem(props) {
  const [imgErr, setImgErr] = useState(false);

  const { good = {}, addToBasket = Function.prototype } = props;

  const {
		displayName,
		displayDescription,
		displayAssets,
		mainId,
		offerId,
		price
  } = good;

  const handleImgErr = () => {
    setImgErr(true);
  }

  return (
		<div
			className='good card'
			id={`${mainId}-${offerId}`}
		>
			<div className='card-image'>
				{imgErr && !displayAssets[0]?.full_background ? (
					<h4>Sorry, img not available</h4>
				) : (
					<img
						src={displayAssets[0]?.full_background}
						alt={displayName}
						onError={handleImgErr}
					/>
				)}
				<div className='card-content'>
					<h5>{displayName}</h5>
					<p>{displayDescription}</p>
				</div>
				<div className='card-action'>
          <button className='btn' onClick={() => {
            addToBasket(good);
          }}>Купить</button>
					<span
						className='right'
						style={{ fontSize: '1.8rem' }}
					>
						{price?.finalPrice}$
					</span>
				</div>
			</div>
		</div>
  );
}

export { GoodItem };